import userLoggedIn from '../scripts/user-logged-in';
import { signInAndReturn } from '../scripts/return-to';
import Enterprise from "./dashboard/enterprise";

// The Alert Map's Table view is this same dashboard, started in place on the
// map's page the first time it is asked for (templates/map/index.js setView):
// boot() gives the one dashboard, started on demand.
window.tsDashboard = {
  instance: null,
  boot() {
    if(!this.instance) this.instance = new Enterprise();
    return this.instance;
  },
};

if(document.querySelector('.dashboard')) {

  // the dashboard fills the viewport: its panes scroll, the page doesn't
  document.body.classList.add('is-full-height');

  // Map | Table: the map takes the search along, as the map's own switch does
  document.querySelectorAll('.dashboard__header [data-view="map"]').forEach(link => link.addEventListener('click', () => {
    const d = window.tsDashboard.instance;
    const q = d && typeof d.currentSearch === 'string' ? d.currentSearch.trim() : '';
    const url = new URL(link.href);
    if(q) url.searchParams.set('q', q);
    else url.searchParams.delete('q');
    link.href = url.toString();
  }));

  userLoggedIn().then(token => {

    if (token === false) {
      signInAndReturn();
      return;
    }

    window.tsDashboard.boot();
  });

}
